import { Component, OnDestroy, OnInit } from '@angular/core';
import { language } from '../../services/language'
import { MessageService } from '../../services/message.service'
import { Subscription } from 'rxjs';
declare var $: any;

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
    /* 
    * Variables
    */

    // enable to sign up section
    protected signUpEnable: boolean = false

    // 
    protected word = language

    protected image: any = null

    protected currentYear: number = new Date().getFullYear();

    protected theme: string | null = null;

    private watcher: Subscription | null = null;

    /* 
    * Life cycles
    */
    constructor(private message: MessageService) { }

    ngOnInit() {
        this.determineTheme()

        // listen changes of another components
        this.watcher = this.message.channelComponents$.subscribe(res => {
            if (res['message'] == 'changeSection') {
                this.signUpEnable = res['value']
            }
        })
    }

    ngOnDestroy(): void {
        if (this.watcher) {
            this.watcher.unsubscribe()
            this.watcher = null
        }
    }

    /* 
    * Functions
    */
    protected listenerChildrens = (e): void => {
        switch (e.message) {
            case 'setImage':
                this.image = e.image
                break
            default:
                break
        }
    }

    private determineTheme = () => {
        this.theme = document.body.dataset.theme
        if (this.theme) {
            return
        }
        
        const darkMode = window.matchMedia('(prefers-color-scheme: dark)');
        if (darkMode.matches) {
            this.theme = 'dark'
            document.body.dataset.theme = 'dark'
            $.App.activateDarkMode()
            return
        }

        this.theme = 'light'
        document.body.dataset.theme = 'light'
        $.App.deactivateDarkMode()
    }

}
